import axios from 'axios'
import { APIReducer, inititalState } from './Reducer'
import { useContext, createContext, useReducer, useEffect, useState } from 'react'
import { ValidateAPI } from '../utils/Utils'
import { set } from 'lodash'
import axiosInstance from '../api/axiosInstance'

const APICALL = createContext()

const APICONTEXT = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('userData'))
  const [state, dispatch] = useReducer(APIReducer, inititalState)

  async function SearchBuyer(role = '') {
    const responce = await axiosInstance
      .get(`/api/search-buyers?searchstring=&roleType=${role}`,)
    const data = responce?.data?.map((buyer) => ({
      value: buyer.BUYER_DETAIL,
      label: buyer.BUYER_DETAIL
    }))
    dispatch({
      type: 'BUYERCOUNT',
      payload: data
    })
    // .then((responce) => {

    // })
    // .catch((err) => {
    //   // return alert("some thing issue ", err)
    // })
  }

  async function SearchSKU(role = '') {
    const responce = await axiosInstance
      .get(`api/get-all-sku?searchString=${role}`)
    const data = responce?.data?.map((SKU) => ({
      value: SKU.sku,
      label: SKU.sku
    }))
    dispatch({
      type: 'SKUCOUNT',
      payload: data
    })
    // .then((responce) => {

    // })
    // .catch((err) => {
    //   // return alert("some thing issue ", err)
    // })
  }


  async function searchVendorORSKU(role = '') {
    const response = await axiosInstance
      .get(`/po/VendorNameOrSKUBySearchString?searchString=${role}`,)
    const data = response?.data?.map((vendor) => ({
      value: vendor.vendorOracleId,
      label:
      vendor?.vendorName?.toLowerCase() === "all vendors"
        ? vendor.vendorName
        : `${vendor.vendorOracleId} - ${vendor.vendorName}`,
  
      labelValue: vendor.vendorName
    }))
    dispatch({
      type: 'VENDORCOUNT',
      payload: data
    })
    // .then((response) => {

    // })
    // .catch((err) => {
    //   // alert("some thing issue ", err)
    // })
  }
  async function getFilterData(userid, tableName) {
    const response = await axiosInstance
      .get(`/filter/preference/getFilterDetails?hftUserId=${userid}&tableName=${tableName}`)
    dispatch({
      type: 'FILTERDATA',
      payload: response?.data
    })
  }
  function addFilterData(payload) {
    axiosInstance
      .post(`/filter/preference/saveOrUpdate`, payload)
      .then((response) => {

      })
      .catch((error) => {

      })
  }
  function SearchSKU(role = '') {
    axiosInstance
      .get(`/api/get-all-sku?searchString=${role}`)
      .then((responce) => {
        const data = responce?.data?.map((SKU) => ({
          value: SKU.sku,
          label: SKU.sku
        }))
        dispatch({
          type: 'SKUCOUNT',
          payload: data
        })
      })
      .catch((err) => {
        // return alert("some thing issue ", err)
      })
  }
  return (
    <APICALL.Provider
      value={{
        state,
        searchVendorORSKU,
        SearchBuyer,
        SearchSKU,
        getFilterData,
        addFilterData,
        SearchSKU
        // updateFilterArray
      }}
    >
      {children}
    </APICALL.Provider>
  )
}

export default APICONTEXT

export const CommonAPICall = () => {
  return useContext(APICALL)
}
